// extracted by mini-css-extract-plugin
export var anchor = "_36-0";
export var discard = "_36-4";
export var muiTooltipTooltip = "_36-6";
export var notificationBar = "_36-3";
export var saveButtonHoverSlotWrapper = "_36-5";
export var show = "_36-2";
export var spacer = "_36-1";